<template>
    <div>
        <v-app>
            
            <v-app-bar app>

                            
                    <div width="210px"></div>
                    
                    <v-spacer></v-spacer>

                    <ThemeSwitch
                    class="themeSwitchClass"
                    :propsChecked="darkTheme"
                    @value="changeTheme"
                    >
                    </ThemeSwitch>

            </v-app-bar>

            <!-- Sizes your content based upon application components -->
            <v-main>

                <!-- Provides the application the proper gutter -->
                <v-container class="container" fluid>

                    <!--child-->
                    <slot></slot>
                
                </v-container>
            </v-main>

            <v-footer
            app
            padless
            >
               
            </v-footer>
        </v-app>

    </div>
</template>

<script>

//css
import "./MainLayout.css"

import ThemeSwitch from "@/components/switch/ThemeSwitch.vue"


export default {

    components:{
        ThemeSwitch
    },


    data: function(){
        return({
            darkTheme: this.$vuetify.theme.dark,
        })
    },
    
    methods:{

        changeTheme(){
            this.darkTheme = !this.darkTheme;
            if (this.darkTheme) {
                this.$vuetify.theme.dark = true;
            } else {
                this.$vuetify.theme.dark = false;
            }
        },


    },

}
</script>

<style scoped>

.themeSwitchClass{
    margin-right: 5px;
}

.messageContainerClass{
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 10px;
}

</style>